import styled from 'styled-components';

export const NavbarWrapper = styled.div`
  @media screen and (max-width: 360px) {
    slot > img {
      content: url(${(p) => p?.theme?.config?.mobileHeaderLogo});
    }
  }
`;

export default NavbarWrapper;
